import type { WhatsAppAiReplyShowResponse } from '@jobilla/nexus-sdk'
import { candidateWhatsAppIndexQueryKey, useWhatsAppAiReplyShow } from '@jobilla/nexus-sdk'
import { useQueryClient } from '@tanstack/react-query'
import { useEffect, useRef } from 'react'

export const AI_STATE_POLL_MS = 5_000

/**
 * Polled because the Echo broadcast is not available in every environment.
 * A state change usually means a message was sent, so the thread refetches too.
 */
export function useWhatsAppAiState(candidateId: string, enabled: boolean): WhatsAppAiReplyShowResponse | undefined {
	const queryClient = useQueryClient()
	const { data } = useWhatsAppAiReplyShow(candidateId, {
		enabled,
		refetchInterval: AI_STATE_POLL_MS,
	})

	const snapshot = data ? `${data.status}:${data.activityState}` : null
	const previousSnapshot = useRef(snapshot)
	useEffect(() => {
		if (previousSnapshot.current !== null && snapshot !== previousSnapshot.current) {
			void queryClient.invalidateQueries({ queryKey: candidateWhatsAppIndexQueryKey(candidateId) })
		}
		previousSnapshot.current = snapshot
	}, [snapshot, candidateId, queryClient])

	return data
}
